<template class="text_google">
  <v-app>
     <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right">
        <v-btn
          large
          rounded
          dark
          href="javascript:window.print()"
          class="title mr-2 rounded"
          color="info"
        >
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>

        <v-btn
        
          @click.stop="
            Export2Doc('exportContent', 'ตำแหน่งว่างหลังการพิจารณาย้าย')
          "
         class="mr-1" color="blue"
       
        >
          <v-icon>mdi-file-word</v-icon>&nbsp; Export to Word
        </v-btn>
        <v-btn
          @click.stop="
            exportToExcel('exportContent', 'ตำแหน่งว่างหลังการพิจารณาย้าย')
          "
          class="mr-1" color="green"
        >
          <v-icon>mdi-file-excel</v-icon>&nbsp; Export to excel
        </v-btn>

      </v-toolbar-items>
    </v-system-bar>

    <div id="exportContent" style="mso-page-orientation: landscape;">
      <div class="page">
        <div align="center">
          <div class="head">
            บัญชีข้อมูลบุคลากร
          </div>
        </div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  รหัสบัตรประชาชน
                </th>
                <th>
                  ชื่อ-นามสกุล
                </th>
                <th>
                    ตำแหน่ง
                </th>
                <th>อันดับ/ระดับ</th>
                <th>วิทยฐานะ</th>
                <th>ประเภท</th>
                <th>ด้าน</th>
                <th>เงินที่ใช้จ้าง</th>
                <th>เงินเดือน</th>
                <th>วุฒิการศึกษาต่ำกว่า ป.ตรี</th>
                <th>วุฒิการศึกษาปริญญาตรี</th>
                <th>วุฒิการศึกษาปริญญาโท</th>
                <th>วุฒิการศึกษาปริญญาเอก</th>
                <th>สาขาวิชาสอน</th>
                <th>สาขาวิชาสอน</th>               
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in personnel_etcs" :key="item.personnel_etc_id_card">
                <td>{{ item.personnel_etc_id_card }}</td>
                <td>{{ item.personnel_etc_title + item.personnel_etc_fristname + " " + item.personnel_etc_lastname }}</td>
                <td> {{ item.personnel_etc_positon }} </td>
                <td> {{ item.personnel_etc_id_position }} </td>
                <td> {{ item.personnel_etc_level }} </td>
                <td> {{ item.personnel_etc_rang }} </td>
                <td> {{ item.personnel_etc_type }} </td>
                <td> {{ item.personnel_etc_about }} </td>
                <td>   <span v-if="item.personnel_etc_budget === 'budget'"
              >จากงบประมาณ</span
            >
            <span v-else-if="item.personnel_etc_budget === 'income'"
              >จากรายได้สถานศึกษา</span
            > </td>
                <td> {{ item.personnel_etc_salary }} </td>
                <td> {{ item.personnel_etc_education_1 }} </td>
                <td> {{ item.personnel_etc_education_2 }} </td>
                <td> {{ item.personnel_etc_education_3 }} </td>
                <td> {{ item.personnel_etc_education_4 }} </td>
                <td> {{ item.personnel_etc_branch_n }} </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    order_appoints: [],
    conditons_transfer_successs: [],
    valid: true,
    headersMap: [
      { text: "รหัส", align: "center", value: "personnel_etc_id_card" },
      { text: "คำนำหน้าชื่อ", align: "center", value: "personnel_etc_title" },
      { text: "ชื่อ", align: "center", value: "personnel_etc_fristname" },
      { text: "นามสกุล", align: "center", value: "personnel_etc_lastname" },
      { text: "ตำแหน่ง", align: "center", value: "personnel_etc_positon" },
      {
        text: "เลขที่ตำแหน่ง",
        align: "center",
        value: "personnel_etc_id_position"
      },
      { text: "อันดับ/ระดับ", align: "center", value: "personnel_etc_level" },
      { text: "วิทยฐานะ", align: "center", value: "personnel_etc_rang" },
      { text: "ประเภท", align: "center", value: "personnel_etc_type" },
      { text: "ด้าน", align: "center", value: "personnel_etc_about" },
      {
        text: "เงินที่ใช้จ้าง",
        align: "center",
        value: "personnel_etc_budget"
      },
      {
        text: "เงินเดือน",
        align: "center",
        value: "personnel_etc_salary"
      },
      {
        text: "ต่ำกว่า ป.ตรี",
        align: "center",
        value: "personnel_etc_education_1"
      },
      {
        text: "ปริญญาตรี",
        align: "center",
        value: "personnel_etc_education_2"
      },
      {
        text: "ปริญญาโท",
        align: "center",
        value: "personnel_etc_education_3"
      },
      {
        text: "ปริญญาเอก",
        align: "center",
        value: "personnel_etc_education_4"
      },
      {
        text: "สาขาวิชาสอน",
        align: "center",
        value: "personnel_etc_branch_n"
      },      
    ],
   
    personnel_etcs: []
  }),

  async mounted() {
    this.personnel_etcsQueryAll();
  },

  methods: {
    async personnel_etcsQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          personnel_etc_college_code: this.url_result
        })
        .finally(() => (this.loading = false));
      this.personnel_etcs = result.data;
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    },
    exportToExcel(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Excel</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msexcel"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".xls" : "document.xls";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },
  props: {
    source: String
  },

  computed: {
     url_result() {
        let result = window.location.href;
        let split_s = result.split("/");
        return split_s[6];
      },
  }
};
</script>
<style>
@import url(https://fonts.googleapis.com/css?family=Prompt:400,300|Roboto:400,300&subset=latin,thai);

body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

.textAlignVer {
  display: block;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  transform: rotate(-90deg);
  position: relative;
  width: 20px;
  white-space: nowrap;
  font-size: 14px;
  margin-bottom: 5;
}

u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 29.7cm;
  min-height: 21cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 0.5cm;
  padding-right: 0.5cm;
  padding-bottom: 0.5cm;
  padding-left: 0.5cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
        height: 247mm;
      }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
        border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
          font-size: 18px;
          font-weight: bold;
        }
        .regular12 {
          font-size: 12px;
        }
        .blod12 {
          font-size: 12px;
          font-weight: bold;
        }
        .blackRegula8 {
          font-size: 8px;
        } */
  .noprint {
    display: none;
  }
}
</style>
